import { render, staticRenderFns } from "./classificagenerale.vue?vue&type=template&id=00b2a8e1&scoped=true&"
import script from "./classificagenerale.vue?vue&type=script&lang=js&"
export * from "./classificagenerale.vue?vue&type=script&lang=js&"
import style0 from "./classificagenerale.vue?vue&type=style&index=0&id=00b2a8e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b2a8e1",
  null
  
)

export default component.exports